import React, {useEffect} from 'react';
import {usePhaseState} from 'funnel-schedule/phase-context';
import SalesIndex from './join';
import track from 'utils/track';

export default function (props) {
  const {
    phases: {
      sales: salesSchedule = {
        phase: 'during',
        salesEnd: ''
      }
    }
  } = usePhaseState();

  useEffect(() => {
    track('Product Viewed', {
      product_id: 'SC-PPP',
      sku: 'SC-PPP',
      name: 'Plant-Powered Playbook',
      variant: salesSchedule.phase != 'during' ? 'ppp' : 'ppp-special',
      value: salesSchedule.phase != 'during' ? 197 : 97,
      currency: 'usd'
    });
  }, [salesSchedule.phase]);

  const salesTimeOverride = new Date(salesSchedule.salesEnd).getTime();

  return (
    <SalesIndex
      ctaOverride={salesSchedule.phase != 'during' ? 'joinFull' : 'joinSales'}
      videoUrlOverride={
        salesSchedule.phase != 'during'
          ? 'https://www.youtube.com/watch?v=wahBUJvGhN0'
          : 'https://www.youtube.com/watch?v=7tH8eoVpvOI'
      }
      timerOverride={salesTimeOverride}
    />
  );
}
